module.exports = __webpack_public_path__ + "img/bx_bx-rotate-right.da6737c4.svg";